import React, { useState } from 'react'
import Blog1 from '../assets/blog_1.png'
import Blog2 from '../assets/blog_2.png'
import Blog3 from '../assets/blog_3.png'
import Blog4 from '../assets/blog_4.png'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

const Blog = () => {
    const [len, setLen] = useState(4)
    const articles = [
        {
            "category": "Fitness",
            "readTime": "9 Min Read",
            "title": "The 7 Best Foods to Jumpstart Your Metabolism",
            "description": "There's no shortage of fad diets promising quick results and a trim waistline. But trying to keep up with...",
            "image": Blog1,
            "link": "/articles/metabolism-foods"
        },
        {
            "category": "Fitness",
            "readTime": "6 Min Read",
            "title": "Why Taking Supplements Consistently Is Essential",
            "description": "Great habits can lead to great health. Think about it; sticking to your good habits can have exponential benefits.",
            "image": Blog2,
            "link": "/articles/supplements-importance"
        },
        {
            "category": "Nutrition",
            "readTime": "13 Min Read",
            "title": "Ashwagandha: The Ancient Herb for Modern Life",
            "description": "If there was ever an herb that satisfies the needs of the modern lifestyle, it's ashwagandha.",
            "image": Blog3,
            "link": "/articles/ashwagandha-benefits"
        },
        {
            "category": "Nutrition",
            "readTime": "10 Min Read",
            "title": "Boron: Health Benefits, Dosage, and Side Effects",
            "description": "You probably haven't thought of boron since your high school chemistry class (and maybe not even then)...",
            "image": Blog4,
            "link": "/articles/boron-benefits"
        },
        {
            "category": "Nutrition",
            "readTime": "13 Min Read",
            "title": "Ashwagandha: The Ancient Herb for Modern Life",
            "description": "If there was ever an herb that satisfies the needs of the modern lifestyle, it's ashwagandha.",
            "image": Blog3,
            "link": "/articles/ashwagandha-benefits"
        },
        {
            "category": "Nutrition",
            "readTime": "10 Min Read",
            "title": "Boron: Health Benefits, Dosage, and Side Effects",
            "description": "You probably haven't thought of boron since your high school chemistry class (and maybe not even then)...",
            "image": Blog4,
            "link": "/articles/boron-benefits"
        },

    ]

    return (
        <div className='py-10 xl:py-[100px] px-[4%] sm:px-[6%] xl:px-[10%] 2xl:px-[12.6%] flex flex-col gap-10 md:gap-[100px] items-center'>
            <Helmet>
                <title>Blog - Supreme Nutra Shop</title>
                <meta name="description" content="This is a detailed description of the page content for better SEO" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="My SEO Optimized Page" />
                <meta property="og:description" content="This is a detailed description of the page content for better SEO" />
                <meta property="og:image" content="https://www.example.com/image.jpg" />
                <link rel="canonical" href="https://www.example.com/page" />
            </Helmet>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-x-[30px] gap-y-[60px]'>
                {articles.slice(0, len).map((article, index) => (
                    <div
                        key={index}
                        className="rounded-lg overflow-hidden bg-white flex flex-col xl:flex-row gap-6"
                    >
                        {/* Image Section */}
                        <img
                            src={article.image}
                            alt={article.title}
                            className="w-full xl:w-[45%] xl:max-w-[338px] h-[280px] object-cover rounded-[20px] xl:h-auto"
                        />

                        {/* Content Section */}
                        <div className=" w-full xl:w-[55%] flex flex-col justify-start items-start text-start">
                            <div>
                                <div className='flex items-center gap-3 text-[16px] font-[500] leading-[26px]'>
                                    <p className="text-gradient bg-gradient-3" >{article.category}</p>
                                    <p className='h-[6px] w-[6px] bg-[#00000040] rounded-full'></p>
                                    <p >{article.readTime}</p>
                                </div>
                                <h3 className="text-[24px] font-[600] leading-[34px] mt-4">{article.title}</h3>
                                <p className="my-[10px] text-secondary text-[16px] font-[400] leading-[26px">{article.description}</p>
                            </div>
                            <Link to={'#'} className="text-[20px] font-[500] leading-[normal]" > Read More → </Link>
                        </div>
                    </div>
                ))}
            </div>
            {
                len === articles.length ? <></> :
                    <button className='btn-primary' onClick={() => setLen((prev) => prev + 2)}>Load More</button>
            }
        </div>

    )
}

export default Blog